// services/api/departmentApi.js
import axiosInstance from "utils/axiosInstance";

const departmentApi = {
  /**
   * Fetches all departments
   * @returns {Promise<Array>} A promise that resolves to an array of department objects
   */
  getDepartments: async () => {
    const response = await axiosInstance.get("/departments/getall");
    return response.data || [];
  },

  /**
   * Creates a new department
   * @param {Object} departmentData - The department data to create
   * @returns {Promise<Object>} A promise that resolves to the created department object
   */
  createDepartment: async (departmentData) => {
    const response = await axiosInstance.post("/departments/create", departmentData);
    return response.data;
  },

  /**
   * Updates an existing department
   * @param {string} departmentId - The ID of the department to update
   * @param {Object} departmentData - The updated department data
   * @returns {Promise<Object>} A promise that resolves to the updated department object
   */
  updateDepartment: async (departmentId, departmentData) => {
    const response = await axiosInstance.put(`/departments/update/${departmentId}`, departmentData);
    return response.data;
  },

  /**
   * Deletes a department
   * @param {string} departmentId - The ID of the department to delete
   * @returns {Promise<Object>} A promise that resolves to the response data
   */
  deleteDepartment: async (departmentId) => {
    const response = await axiosInstance.delete(`/departments/delete/${departmentId}`);
    return response.data;
  }
};

export default departmentApi;